<script lang="ts">
	import type { WebProduct } from "@core/schema/WebProduct.js";
	import { getProductsCatalogueDetailPath } from "@core/schema/paths/getProductsCatalogueDetailPath.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import StructuredData from "./common/StructuredData.svelte";

	const { FILE_BUCKET_URL_MAP, WEB_URL } = getGlobalSettings();
	const { product }: { product: WebProduct } = $props();

	const image = $derived.by(() => {
		for (const item of product.gallery) {
			if (item.photo !== undefined) {
				return item.photo;
			}
		}
		return undefined;
	});
</script>

<StructuredData
	data={{
		"@type": "Product",
		name: product.name,
		description: product.perex,
		image: image && `${FILE_BUCKET_URL_MAP[image.bucket]}/${image.path}`,
		url: `${WEB_URL}${getProductsCatalogueDetailPath(product)}`,
		category: product.categories.map(({ name }) => name),
		keywords: product.metaKeywords,
		brand: product.company && {
			"@type": "Brand" as const,
			name: product.company.name,
		},
	}}
/>
